import styled from 'styled-components'

export const View = styled.div`
  * {
    box-sizing: border-box;
  }
`
